import { Box } from '@mui/material';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import DisplayLanguageTabList from './display-language-tab-list/display-language-tab-list.component';

type DisplayLanguageDroppableWrapperProps = {
  value: any;
  handleTabChange: (_e: any, selectedTab: any) => void;
  handleTabDragEnd: (result: any) => void;
};

const DisplayLanguageDroppableWrapper = ({
  value,
  handleTabChange,
  handleTabDragEnd,
}: DisplayLanguageDroppableWrapperProps) => {
  return (
    <DragDropContext onDragEnd={handleTabDragEnd}>
      <Box display="flex" overflow="auto">
        <Droppable droppableId="1" direction="horizontal">
          {droppableProvided => (
            <Box
              ref={droppableProvided.innerRef}
              {...droppableProvided.droppableProps}
            >
              <DisplayLanguageTabList
                value={value}
                droppableProvided={droppableProvided}
                handleTabChange={handleTabChange}
              />
            </Box>
          )}
        </Droppable>
      </Box>
    </DragDropContext>
  );
};

export default DisplayLanguageDroppableWrapper;
